export enum WeightUnit {
  G = 'g',
  KG = 'kg',
  OZ = 'oz',
  LB = 'lb',
}

export const weightUnitMap: Record<string, WeightUnit> = {
  [WeightUnit.G]: WeightUnit.G,
  [WeightUnit.KG]: WeightUnit.KG,
  [WeightUnit.OZ]: WeightUnit.OZ,
  [WeightUnit.LB]: WeightUnit.LB,
};

type SafeWeightUnitMap<K extends keyof typeof WeightUnit = keyof typeof WeightUnit> = Record<
  Lowercase<K>,
  (typeof WeightUnit)[K]
>;

// There's really no reason that this can't replace `weightUnitMap`. I'm just not prepared to check usages of the existing one.
// If you're trying to choose between the two, you should use this one. Your IDE will know what keys it has and help you with autocompletion.
export const safeWeightUnitMap: SafeWeightUnitMap = {
  g: WeightUnit.G,
  kg: WeightUnit.KG,
  oz: WeightUnit.OZ,
  lb: WeightUnit.LB,
};

/**
 * Maps to the api_unit table
 */
export enum ApiUnit {
  Centimetre = 1,
  Inch = 2,
  Foot = 3,
  Gram = 4,
  Ounce = 5,
  Pound = 6,
  Kilogram = 7,
  Metre = 8,
  Millimetre = 9,
  Yard = 10,
  Kilometre = 11,
  Mile = 12,
}

export const apiUnitMap: Record<string, ApiUnitWeight> = {
  [WeightUnit.G]: ApiUnit.Gram,
  [WeightUnit.KG]: ApiUnit.Kilogram,
  [WeightUnit.OZ]: ApiUnit.Ounce,
  [WeightUnit.LB]: ApiUnit.Pound,
};

export type ApiUnitWeight = ApiUnit.Gram | ApiUnit.Kilogram | ApiUnit.Ounce | ApiUnit.Pound;

export const apiUnitWeightMap: Record<ApiUnitWeight, WeightUnit> = {
  [ApiUnit.Gram]: WeightUnit.G,
  [ApiUnit.Kilogram]: WeightUnit.KG,
  [ApiUnit.Ounce]: WeightUnit.OZ,
  [ApiUnit.Pound]: WeightUnit.LB,
};
